import camelcase from 'camelcase';
import { mapValues } from 'lodash-es';

const LDFlags = {
  CovidQtyAndScreener: 'covid-quantity-select-and-skip-eligibility',
  CartUpsell: 'cart-upsell',
};

export const Flags = mapValues(LDFlags, flag => camelcase(flag));
